import React, { useEffect, useState } from 'react';

import { ENVS, getEnv } from '@adsk/acs-sc-web-platform-api';
import theme from '@adsk/alloy-react-theme';

const EnvLabel = () => {
  const [envLabel, setEnvLabel] = useState('');

  useEffect(() => {
    const env = getEnv();
    if (env !== ENVS.PRODUCTION) {
      setEnvLabel(env);
    }
  }, []);

  return envLabel ? (
    <div
      css={[
        {
          position: 'fixed',
          padding: '0 5px',
          lineHeight: '18px',
          fontSize: 13,
          left: '50%',
          background: theme.colors.green300,
          color: theme.colors.white,
        },
      ]}
    >
      {envLabel}
    </div>
  ) : null;
};

EnvLabel.displayName = 'EnvLabel';

export default EnvLabel;
